import { Navigate, createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Shield } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../stores/auth";
import { SectionTitle, type AdminUser } from "../components/admin/shared";
import { CreateGlobalUserForm, UserTable } from "../components/admin/user-management";

export const Route = createFileRoute("/admin/global-admins")({
  component: AdminGlobalAdminsPage,
});

function AdminGlobalAdminsPage() {
  const user = useAuth((s) => s.user);
  const globalUsersQ = useQuery({
    queryKey: ["admin", "global-users"],
    enabled: user?.role === "global_admin",
    queryFn: () => api<{ users: AdminUser[] }>("/admin/global-users"),
  });
  if (!user) return null;
  if (user.role !== "global_admin") return <Navigate to="/admin/users" replace />;
  return (
    <section className="space-y-4">
      <SectionTitle icon={<Shield size={18} />} title="Global admins" />
      <CreateGlobalUserForm />
      <UserTable
        users={globalUsersQ.data?.users ?? []}
        kind="global"
        disabled={globalUsersQ.isLoading}
      />
    </section>
  );
}
